export const imageContainer = "i1418gms";
export const label = "l1up1w6c";
export const labelTitle = "l1pkghji";
export const labelContainer = "lr45yac";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");